import React, { FC } from 'react'
import AnimatedCountBadge from '../common/animated-count-badge/animated-count-badge'

const MessagesBadge: FC<{ count: number; scope?: string }> = ({ count, scope = '' }) => (
  <AnimatedCountBadge count={count} scope={scope} label="Новых сообщений" compact />
)

export default MessagesBadge
